<template>
  <div>
    <vx-card class="mb-4">
      <table class="w-full">
        <tr>
          <th>제작사</th>
          <th>구분</th>
          <th>입고수량</th>
          <th>출고수량</th>
          <th>재고수량</th>
        </tr>
        <tr v-if="$store.state.AppActiveUser.vendors.includes('HK-MNS')">
          <th rowspan="8">HK-MNS</th>
          <th>ATC-A</th>
          <td>{{ inventory.incoming['ATC-A'] }}</td>
          <td>{{ inventory.outgoing['ATC-A'] }}</td>
          <td>{{ inventory.incoming['ATC-A'] - inventory.outgoing['ATC-A'] }}</td>
        </tr>
        <tr v-if="$store.state.AppActiveUser.vendors.includes('HK-MNS')">
          <th>ATC-A2</th>
          <td>{{ inventory.incoming['ATC-A2'] }}</td>
          <td>{{ inventory.outgoing['ATC-A2'] }}</td>
          <td>{{ inventory.incoming['ATC-A2'] - inventory.outgoing['ATC-A2'] }}</td>
        </tr>
        <tr v-if="$store.state.AppActiveUser.vendors.includes('HK-MNS')">
          <th>ATC-B</th>
          <td>{{ inventory.incoming['ATC-B'] }}</td>
          <td>{{ inventory.outgoing['ATC-B'] }}</td>
          <td>{{ inventory.incoming['ATC-B'] - inventory.outgoing['ATC-B'] }}</td>
        </tr>
        <tr v-if="$store.state.AppActiveUser.vendors.includes('HK-MNS')">
          <th>ATC-C</th>
          <td>{{ inventory.incoming['ATC-C'] }}</td>
          <td>{{ inventory.outgoing['ATC-C'] }}</td>
          <td>{{ inventory.incoming['ATC-C'] - inventory.outgoing['ATC-C'] }}</td>
        </tr>
        <tr v-if="$store.state.AppActiveUser.vendors.includes('HK-MNS')">
          <th>H3(반도)</th>
          <td>{{ inventory.incoming['H3(반도)'] }}</td>
          <td>{{ inventory.outgoing['H3(반도)'] }}</td>
          <td>{{ inventory.incoming['H3(반도)'] - inventory.outgoing['H3(반도)'] }}</td>
        </tr>
        <tr v-if="$store.state.AppActiveUser.vendors.includes('HK-MNS')">
          <th>H2(반도)</th>
          <td>{{ inventory.incoming['H2(반도)'] }}</td>
          <td>{{ inventory.outgoing['H2(반도)'] }}</td>
          <td>{{ inventory.incoming['H2(반도)'] - inventory.outgoing['H2(반도)'] }}</td>
        </tr>
        <tr v-if="$store.state.AppActiveUser.vendors.includes('HK-MNS')">
          <th>H3(볼트)</th>
          <td>{{ inventory.incoming['H3(볼트)'] }}</td>
          <td>{{ inventory.outgoing['H3(볼트)'] }}</td>
          <td>{{ inventory.incoming['H3(볼트)'] - inventory.outgoing['H3(볼트)'] }}</td>
        </tr>
        <tr v-if="$store.state.AppActiveUser.vendors.includes('HK-MNS')">
          <th>H2(볼트)</th>
          <td>{{ inventory.incoming['H2(볼트)'] }}</td>
          <td>{{ inventory.outgoing['H2(볼트)'] }}</td>
          <td>{{ inventory.incoming['H2(볼트)'] - inventory.outgoing['H2(볼트)'] }}</td>
        </tr>
        <tr v-if="$store.state.AppActiveUser.vendors.includes('END')">
          <th rowspan="4">END</th>
          <th>소형복합</th>
          <td>{{ inventory.incoming['소형복합'] }}</td>
          <td>{{ inventory.outgoing['소형복합'] }}</td>
          <td>{{ inventory.incoming['소형복합'] - inventory.outgoing['소형복합'] }}</td>
        </tr>
        <tr v-if="$store.state.AppActiveUser.vendors.includes('END')">
          <th>중형복합</th>
          <td>{{ inventory.incoming['중형복합'] }}</td>
          <td>{{ inventory.outgoing['중형복합'] }}</td>
          <td>{{ inventory.incoming['중형복합'] - inventory.outgoing['중형복합'] }}</td>
        </tr>
        <tr v-if="$store.state.AppActiveUser.vendors.includes('END')">
          <th>대형복합</th>
          <td>{{ inventory.incoming['대형복합'] }}</td>
          <td>{{ inventory.outgoing['대형복합'] }}</td>
          <td>{{ inventory.incoming['대형복합'] - inventory.outgoing['대형복합'] }}</td>
        </tr>
        <tr v-if="$store.state.AppActiveUser.vendors.includes('END')">
          <th>SCR</th>
          <td>{{ inventory.incoming['SCR'] }}</td>
          <td>{{ inventory.outgoing['SCR'] }}</td>
          <td>{{ inventory.incoming['SCR'] - inventory.outgoing['SCR'] }}</td>
        </tr>
      </table>
    </vx-card>
  </div>
</template>

<script>
export default {
  
  data () {
    return {
      inventory: {
        incoming: {},
        outgoing: {}
      }
    }
  },
  created () {
    this.$db.doc('statuses/inventory').get().then((doc) => {
      this.inventory = doc.data()
    })
  }
}
</script>